var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMealPlanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6859 16.7391C24.6852 16.7462 24.6846 16.7525 24.6842 16.7579L24.6859 16.7391ZM24.6859 16.7391C24.6867 16.728 24.6875 16.7101 24.6886 16.6747C24.6887 16.6706 24.6888 16.6662 24.689 16.6614C24.6895 16.6431 24.6902 16.6194 24.6912 16.593C24.6826 16.5872 24.6689 16.579 24.6483 16.5693C24.5921 16.5428 24.5136 16.519 24.4194 16.5024C24.3334 16.4872 24.2542 16.4815 24.1992 16.4797H1.23417C1.11003 16.4797 1.03982 16.4955 1.0073 16.5057C1.0056 16.5136 1.00403 16.5226 1.00272 16.5327C1.51724 22.9611 6.65395 27.9499 12.8469 27.9499C18.9674 27.9499 24.0639 23.0843 24.6832 16.7703L24.6859 16.7391Z",
    fill: "black",
    stroke: "currentColor",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.3466,
    y1: 1.39269,
    x2: 12.2618,
    y2: 12.9424,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.1756,
    y1: 6.67478,
    x2: 16.225,
    y2: 13.3877,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealPlanner);
export default __webpack_public_path__ + "static/media/meal-planner.bd10dcfb.svg";
export { ForwardRef as ReactComponent };